export default __webpack_public_path__ + "static/media/Filters.f617129e.svg";